export const onEdgesDelete = (reactflow) => {
  return (params) => {
    /**
     * [
    {
        "id": "connectors-connector-1-statements-statement-2",
        "source": "connectors-connector-1",
        "target": "statements-statement-2",
        "animated": true,
        "selected": true
			}
		]
		 */
    /**
     * Once the edge/edges are deleted connecting references we show in the form should be deleted too
     */
  };
};
